import { useMemo, useState } from "react";

export const ITEMS_PER_PAGE = 7;

interface UsePaginationResult<T> {
  currentPageItems: T[];
  currentPage: number;
  startItem: number;
  endItem: number;
  totalItems: number;
  handlePageChange: (page: number) => void;
}

export const usePagination = <T,>(items: T[]): UsePaginationResult<T> => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalItems = items.length;

  const startItem = (currentPage - 1) * ITEMS_PER_PAGE + 1;
  const endItem = Math.min(currentPage * ITEMS_PER_PAGE, totalItems);

  const currentPageItems = useMemo(() => {
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    return items.slice(startIndex, endIndex);
  }, [items, currentPage]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return {
    currentPageItems,
    currentPage,
    startItem,
    endItem,
    totalItems,
    handlePageChange,
  };
};
